/** Shared by rendered links and redirects. Set NEXT_PUBLIC_DOCS_URL for local review. */
export function docsHref(path = "", origin = process.env.NEXT_PUBLIC_DOCS_URL ?? "https://docs.mlx.systems") {
  const url = new URL(origin);
  const local = url.hostname === "localhost" || url.hostname.endsWith(".localhost");
  if (url.username || url.password || url.search || url.hash || url.pathname !== "/" ||
      (url.protocol !== "https:" && !(process.env.NODE_ENV !== "production" && local && url.protocol === "http:")) ||
      (process.env.NODE_ENV === "production" && local)) {
    throw new Error("NEXT_PUBLIC_DOCS_URL must be a Docs origin; local origins are development-only.");
  }
  if (path && (!path.startsWith("/") || path.startsWith("//"))) throw new Error("Expected a Docs-relative path.");
  return `${url.origin}/docs${path}`;
}
